// components/ChatListItem.jsx
export default function ChatListItem({ userId, msg, onSelect }) {
  const lastMessagePreview =
    msg.type === 'image'
      ? msg.role === 'user'
        ? 'Customer sent a photo.'
        : 'You’ve sent a photo.'
      : msg.customer || '';

  return (
    <div
      className="flex items-start gap-3 p-4 cursor-pointer hover:bg-gray-50"
      onClick={() => onSelect(userId)}
    >
      <img
        src={msg.pictureUrl || '/default-avatar.png'}
        alt="avatar"
        className="w-12 h-12 rounded-full object-cover"
      />
      <div className="flex-1">
        <div className="flex justify-between items-center">
          <span className="font-medium">{msg.displayName || 'Unknown'}</span>
          <span className="text-xs text-gray-500">
            {msg.createdAt
              ? new Date(msg.createdAt.toDate()).toLocaleTimeString('th-TH', {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : ''}
          </span>
        </div>
        <p className="text-sm text-gray-600 line-clamp-1 break-all">
          {lastMessagePreview}
        </p>
      </div>
    </div>
  );
}
